// 全屏-会议室
<template>
  <div class="DkbFMR">
    会议室内容
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbFMR',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbFMR {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/MR.vue